<template>
  <header
    component-name="app-header"
    class="relative top-0 left-0 flex justify-center items-center h-20 text-skin-base bg-skin-base"
  >
    <vector-logo-brand data-lag="0.06" />
  </header>
</template>

<style scoped>
html[data-header-use-border=""] header[component-name="app-header"],
html[data-header-use-border="true"] header[component-name="app-header"] {
  @apply border-b border-skin-inverted;
}
</style>
